import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Modal from "react-bootstrap/Modal";
import {Badge, Col, Row, Spinner} from "react-bootstrap";
import Input from "../../../../common/Input";
import moment from "moment/moment";
import Dropdown from "../../../../primer/Dropdown";
import BetterCheckBox from "../../../../common/BetterCheckBox";
import {
    asArray, getActiveSubstance,
    getMultiselectICD10sOptions, getPrescriptionDrugAmountOptions,
    prescriptionDoseAmountOptions,
    prescriptionFrequencyOptions,
    prescriptionParticipationPercentageOptions
} from "../constants";
import Button from "react-bootstrap/Button";
import TextArea from "../../../../common/TextArea";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import {toast} from "react-toastify";
import axios from "axios";
import {
    resetNewPrescription,
    setNewPrescription,
} from "../../../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import ICD10Modal from "./ICD10Modal";
import ConsumablesModal from "./consumablesModal";
import DateBox from "../../../../primer/DateBox";
import {doctorSpecialties} from "../Data/doctorSpecialties";
import {getZeroParticipationReasonOptions} from "../Data/zeroParticipationReasons";
import {getNoInnCasesOptions} from "../Data/noInnCases";
import {referralOverrides} from "../Data/referralOverrides";
import DrugsModal from "./drugsModal";
import IFETDrugTable from "./ifetDrugTable";

const NewPrescriptionModal = ({show, setShow, successCallback, noPaperConstent, amka, ekasLoss,
                                  activePartException, activeVisitTreatmentProtocols, activeVisitTreatmentProtocolsSteps}) => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const newPrescription = useSelector((state) => state.PRESCRIPTION.newPrescription);
    const [commercialUsageAvailable, setCommercialUsageAvailable] = useState(true);

    const [loading, setLoading] = useState(false);
    const [lastError, setLastError] = useState("");

    const [icd10modal, setICD10Modal] = useState(false);

    const [showChooseDrugModal, setShowChooseDrugModal] = useState(false);

    const [extraInfoDrugs, setExtraInfoDrugs] = useState([]); // ids of drugs that has more info open

    const [showOverrides, setShowOverrides] = useState(false);

    const [showConsumablesModal, setShowConsumablesModal] = useState(false);

    const hasActivePartException = !isEmpty(newPrescription.activePartException?.id);

    const prescriptionTypes = [
        { value: "normal", label: "Συνταγογράφηση φαρμάκων" },
        { value: "ifet", label: "Συνταγογράφηση φαρμάκων εξωτερικού μέσω ΙΦΕΤ" },
        //{ value: "consumable", label: "Συνταγογράφηση αναλωσίμων" },
        //{ value: "gal", label: "Συνταγογράφηση γαληνικών σκευασμάτων" },
    ]

    const prescriptionRepeatOptions = [
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
        { value: "5", label: "5" },
        { value: "6", label: "6" },
    ]

    const prescriptionRepeatPeriodObj = {
        "1" : [],
        "2" : [
            {label: "2 μήνες (60 ημέρες)", value: "3"}
        ],
        "3" : [
            {label: "1 μήνας (30 ημέρες)", value: "1"},
            {label: "4 εβδομάδες (28 ημέρες)", value: "2"},
            {label: "2 μήνες (60 ημέρες)", value: "3"},
        ],
        "4" : [
            {label: "1 μήνας (30 ημέρες)", value: "1"},
            {label: "4 εβδομάδες (28 ημέρες)", value: "2"},
        ],
        "5" : [
            {label: "1 μήνας (30 ημέρες)", value: "1"},
            {label: "4 εβδομάδες (28 ημέρες)", value: "2"},
        ],
        "6" : [
            {label: "1 μήνας (30 ημέρες)", value: "1"},
            {label: "4 εβδομάδες (28 ημέρες)", value: "2"},
        ],
    }

    const prescriptionRepeatPeriodOptions = prescriptionRepeatPeriodObj[newPrescription.repeat];

    const dAmount = { // Based on repeatPeriod
        "1": [
            { value: "1", label: "1 ημέρα" },
            ...Array.from({length: 29}, (_, i) => {
                return {
                    value: String(i + 2),
                    label: `${i + 2} ημέρες`
                }
            })
        ],
        "2": [
            { value: "1", label: "1 ημέρα" },
            ...Array.from({length: 27}, (_, i) => {
                return {
                    value: String(i + 2),
                    label: `${i + 2} ημέρες`
                }
            })
        ],
        "3": [
            { value: "1", label: "1 ημέρα" },
            ...Array.from({length: 59}, (_, i) => {
                return {
                    value: String(i + 2),
                    label: `${i + 2} ημέρες`
                }
            })
        ]
    }

    const daysAmount = dAmount[newPrescription.repeatPeriod] || dAmount["1"];

    const consumableCategories = [
        {value: "1", label: "Σακχαρώδης Διαβήτης"},
        {value: "2", label: "Όχι Διαβήτη"},
    ]

    useEffect(() => {
        if (show) {
            const prepNewPrescription = {
                ...newPrescription,
                date: moment().toDate(),
                ekasLoss: ekasLoss,
            }
            if (activePartException) {
                if (Object.keys(activePartException).length > 0) prepNewPrescription.activePartException = activePartException;
            }
            dispatch(setNewPrescription(prepNewPrescription));
            fetchCommercialUsageAvailability();
        } else {
            resetModal();
        }
    }, [show]);

    useEffect(() => {
        if (!showOverrides) {
            dispatch(setNewPrescription({...newPrescription, overrides: []}));
        }
    }, [showOverrides])

    const resetModal = () => {
        dispatch(resetNewPrescription());
        setLastError("");
        setShowOverrides(false);
        setExtraInfoDrugs([]);
    }

    const handleSavePrescription = () => {
        // Validation
        if (newPrescription.diagnoses.length === 0) {
            return toast.error("Παρακαλώ συμπληρώστε τουλάχιστον μία διάγνωση.");
        }
        if (newPrescription.type === "normal") {
            if (newPrescription.prescriptionWithCommercialName && isEmpty(newPrescription.prescriptionWithCommercialNameCause)) {
                return toast.error("Παρακαλώ επιλέξτε αιτιολογία στην συνταγογράφηση με εμπορική ονομασία.");
            } else if (newPrescription.drugs.length === 0) {
                return toast.error("Παρακαλώ συμπληρώστε τουλάχιστον ένα φάρμακο.");
            } else if (newPrescription.drugs.some((el) => isEmpty(el.erp_drugAmount) || isEmpty(el.erp_participationPercentage)
                || isEmpty(el.erp_doseAmount) || isEmpty(el.erp_frequency) || isEmpty(el.erp_days)
                || isEmpty(el.erp_correlated_icd10s) || el?.erp_correlated_icd10s?.length === 0)) {
                return toast.error("Παρακαλώ συμπληρώστε όλα τα απαραίτητα στοιχεία σε κάθε φάρμακο.");
            }
        } else if (newPrescription.type === "ifet") {
            if (newPrescription.ifet.length === 0) {
                return toast.error("Παρακαλώ συμπληρώστε τουλάχιστον μία θεραπεία.");
            } else if (newPrescription.ifet.some((el) => isEmpty(el.erp_active_substance) || isEmpty(el.erp_form)
                || isEmpty(el.erp_content) || isEmpty(el.erp_participationPercentage) || isEmpty(el.erp_doseAmount)
                || isEmpty(el.erp_doseUnit) || isEmpty(el.erp_frequency) || isEmpty(el.erp_days))) {
                return toast.error("Παρακαλώ συμπληρώστε όλα τα απαραίτητα στοιχεία σε κάθε θεραπεία.");
            }
        }

        if (newPrescription.overrides.some((el) => isEmpty(el.erp_cause))) {
            return toast.error("Παρακαλώ συμπληρώστε όλες τις αιτιολογίες στις εξαιρέσεις/υπερβάσεις συνταγής.");
        } else if (newPrescription.overrides.some((el) => String(el.erp_checked) !== "true")) {
            return toast.error("Παρακαλώ αποδεχτείτε όλες τις εξαιρέσεις/υπερβάσεις συνταγής.");
        }

        if (newPrescription.medicalOpinion) {
            if (newPrescription.medicalOpinionByNumber) {
                if (isEmpty(newPrescription.medicalOpinionNumber)) {
                    return toast.error("Παρακαλώ συμπληρώστε αριθμό γνωμάτευσης");
                } else if (isEmpty(newPrescription.medicalOpinionIdentifier)) {
                    return toast.error("Παρακαλώ επιλέξτε αναζήτηση στην ιατρική γνωμάτευση.");
                }
            } else {
                if (isEmpty(newPrescription.medicalOpinionIdentifier)) {
                    return toast.error("Παρακαλώ επιλέξτε αναζήτηση στην ιατρική γνωμάτευση.");
                } else if (isEmpty(newPrescription.medicalOpinionDate)) {
                    return toast.error("Παρακαλώ επιλέξτε ημερομηνία ιατρικής γνωμάτευσης.");
                }
            }
            if (!newPrescription.homeDelivery) {
                return toast.error("Όταν τίθεται τιμή για τον ηλεκτρονικό κωδικό γνωμάτευσης πρέπει να έχει επιλεγεί η δυνατότητα κατ'οίκον παραλαβής των σκευασμάτων από τον/την ασθενή.", {autoClose: 10000});
            }
        }

        const clonePrescription = structuredClone(newPrescription);

        // Hook TP step into drug
        if (activeVisitTreatmentProtocolsSteps?.length > 0) {
            for (let drug of clonePrescription.drugs) {
                const matchingStep = activeVisitTreatmentProtocolsSteps.find((el) => el.atcCode === drug.atcCode);
                if (matchingStep) {
                    if (matchingStep?.patientStep?.id) drug.erp_tpstep_id = matchingStep.patientStep.id;
                    if (matchingStep?.patientStep?.description) drug.erp_tpstep_description = matchingStep.patientStep.description;
                }
            }
        }

        // Post to API
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/new-prescription`, {...clonePrescription, company: company.id}, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                toast.success("Επιτυχής καταχώρηση συνταγής.");
                if (noPaperConstent === "true") {
                    toast.success("Ο ασθενής έχει ενεργοποιημένη άυλη συνταγογράφηση και η συνταγή έχει σταλεί στο κινητό/email του.", {autoClose: 10000});
                }
                setShow(false);
                dispatch(resetNewPrescription());
                setLastError("");
                if (showOverrides) setShowOverrides(false);
                successCallback();
            } else {
                setLastError(res.data.message);
                if (res.data?.specialCode === "1") {
                    setShowOverrides(true);
                    const extraDetails = asArray(res.data.extraDetails);
                    let prepOverrides = [];
                    for (let ed of extraDetails) {
                        prepOverrides.push({
                            ...ed,
                            parentId: referralOverrides.find((el) => el.id === ed.overrideTypeId)?.parentId || "",
                            erp_cause: "",
                            erp_checked: false,
                            erp_override_name: referralOverrides.find((el) => el.id === ed.overrideTypeId)?.description,
                        })
                    }
                    dispatch(setNewPrescription({...newPrescription, overrides: prepOverrides}));
                    toast.error("Παρακαλώ συμπληρώστε τις εξαιρέσεις/υπερβάσεις συνταγής που χρειάζονται.");
                } else {
                    toast.error(res.data.message);
                }
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOnChange = (e, type, name) => {
        let prepChange = {};
        if (type === "dd") {
            if (name === "repeat") {
                prepChange.repeat = e.value;
                prepChange.repeatPeriod = prescriptionRepeatPeriodObj[e.value][0] ? prescriptionRepeatPeriodObj[e.value][0].value : "";
                if (+e.value >= 2) {
                    prepChange.monthlyTreatment = false;
                    prepChange.bimonthlyTreatment = false;
                    prepChange.chronicIllness = true;
                } else {
                    prepChange.monthlyTreatment = false;
                    prepChange.bimonthlyTreatment = false;
                    prepChange.chronicIllness = false;
                }
            } else {
                if (name === "type") {
                    if (newPrescription.type !== e.value) {
                        prepChange["drugs"] = [];
                        prepChange["ifet"] = [];
                        prepChange["oneDose"] = false;
                        prepChange["prescriptionWithCommercialName"] = false;
                        prepChange["prescriptionWithCommercialNameCause"] = "";
                        prepChange["prescriptionWithCommercialNameNotes"] = "";
                    }
                }
                prepChange[name] = e.value;
            }
        } else if (type === "cb") {
            if (name === "monthlyTreatment" || name === "bimonthlyTreatment") {
                prepChange.chronicIllness = true;
            }
            if (name === "prescriptionWithCommercialName" && !e.target.checked) {
                prepChange.prescriptionWithCommercialNameCause = "";
                prepChange.prescriptionWithCommercialNameNotes = "";
            }
            if (name === "medicalOpinion" || name === "medicalOpinionByNumber") {
                prepChange.medicalOpinionByNumber = false;
                prepChange.medicalOpinionNumber = "";
                prepChange.medicalOpinionIdentifier = "";
                prepChange.medicalOpinionAMKA = "";
                prepChange.medicalOpinionDate = "";
            }
            prepChange[name] = e.target.checked;
        } else if (type === "cb_string") {
            prepChange[name] = String(e.target.checked);
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "db") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        }
        dispatch(setNewPrescription({
            ...newPrescription,
            ...prepChange,
        }));
    }

    const handleICD10Check = (e, icd10) => {
        if (e.target.checked) {
            dispatch(setNewPrescription({...newPrescription, diagnoses: [...newPrescription.diagnoses, icd10]}));
        } else {
            dispatch(setNewPrescription({...newPrescription, diagnoses: newPrescription.diagnoses.filter((el) => el.id !== icd10.id)}));
        }
    }

    const handleDrugCheck = (checked, drug) => {
        if (checked) {
            const cloneDrug = structuredClone(drug);
            if (cloneDrug.inClusterWithGeneric === "true") cloneDrug.erp_generic_cluster = "true";
            if (cloneDrug.defaultPercentage === "true") {
                if (+cloneDrug.participationPercentage === 0 || hasActivePartException) { // Special case for 0%
                    cloneDrug.erp_participationPercentage = "1";
                } else if (+cloneDrug.participationPercentage > 0) {
                    cloneDrug.erp_participationPercentage = String(+cloneDrug.participationPercentage);
                }
            }
            if (activeVisitTreatmentProtocolsSteps?.length > 0) {
                const matchingStep = activeVisitTreatmentProtocolsSteps.find((el) => el.atcCode === drug.atcCode);
                if (matchingStep) {
                    if (matchingStep?.patientStep?.id) cloneDrug.erp_tpstep_id = matchingStep.patientStep.id;
                    if (matchingStep?.patientStep?.description) cloneDrug.erp_tpstep_description = matchingStep.patientStep.description;
                }
            }
            setShowChooseDrugModal(false);
            setExtraInfoDrugs([...extraInfoDrugs, cloneDrug.id]);
            dispatch(setNewPrescription({...newPrescription, drugs: [...newPrescription.drugs, cloneDrug]}));
        } else {
            dispatch(setNewPrescription({...newPrescription, drugs: newPrescription.drugs.filter((el) => el.id !== drug.id)}));
        }
    }

    const handleOnDrugChange = (e, type, name, rowIdx) => {
        if (type === "dd") {
            const copyDrugs = structuredClone(newPrescription.drugs);
            copyDrugs[rowIdx][name] = e.value;
            dispatch(setNewPrescription({...newPrescription, drugs: copyDrugs}));
        } else if (type === "input") {
            const copyDrugs = structuredClone(newPrescription.drugs);
            copyDrugs[rowIdx][name] = e.target.value;
            dispatch(setNewPrescription({...newPrescription, drugs: copyDrugs}));
        } else if (type === "msdd") {
            if (name === "erp_correlated_icd10s") {
                const copyDrugs = structuredClone(newPrescription.drugs);
                copyDrugs[rowIdx][name] = e.flatMap((o) => o.value);
                dispatch(setNewPrescription({...newPrescription, drugs: copyDrugs}));
            }
        } else if (type === "cb") {
            const copyDrugs = structuredClone(newPrescription.drugs);
            copyDrugs[rowIdx][name] = String(e.target.checked);
            dispatch(setNewPrescription({...newPrescription, drugs: copyDrugs}));
        }
    }

    const handleOverrideChange = (e, type, name, idx) => {
        const cloneOverrides = structuredClone(newPrescription.overrides);
        if (type === "input") {
            cloneOverrides[idx][name] = e.target.value;
        } else if (type === "cb") {
            cloneOverrides[idx][name] = e.target.checked;
        } else if (type === "dd") {
            if (name === "erp_reasonId") cloneOverrides[idx]["erp_cause"] = e.label;
            cloneOverrides[idx][name] = e.value;
        }
        dispatch(setNewPrescription({...newPrescription, overrides: cloneOverrides}));
    }

    const handleAddConsumable = (item) => {
        const cloneItem = structuredClone(item);
        const cloneConsumables = structuredClone(newPrescription.consumables);
        cloneConsumables.push(cloneItem);
        dispatch(setNewPrescription({...newPrescription, consumables: cloneConsumables}));
    }

    const handleFetchOtherDoctor = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/other-doctor-info`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
                amka: newPrescription.medicalOpinionAMKA,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setNewPrescription({
                    ...newPrescription,
                    medicalOpinionIdentifier: `${res.data.data.lastName} ${res.data.data.firstName}`,
                    medicalOpinionSpecialtyId: doctorSpecialties.find((el) => el.name === res.data.data.specialty)?.id || "",
                }))
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleFetchMedicalOpinion = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/medical-opinion`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
                amka: amka,
                barcode: newPrescription.medicalOpinionNumber,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setNewPrescription({
                    ...newPrescription,
                    medicalOpinionIdentifier: `${res.data.data.doctorName}`,
                    medicalOpinionDate: `${moment(res.data.data.mediOpinionDate, "YYYY-MM-DD").format("DD/MM/YYYY")}`,
                    medicalOpinionSpecialtyId: res.data.data.specialtyId,
                }))
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleAddTPICD10s = () => {
        const currentVisitStepIds = activeVisitTreatmentProtocolsSteps.map((o) => o?.patientStep?.id).filter(Boolean);
        const matchingTPs = activeVisitTreatmentProtocols.filter((el) => asArray(el?.steps?.step)?.some((el) => currentVisitStepIds.includes(el.id)));
        let cloneDiagnoses = structuredClone(newPrescription.diagnoses);
        for (let matchingTP of matchingTPs) {
            if (matchingTP?.treatmentProtocolICD10s?.treatmentProtocolICD10) {
                let icd10sTemp;
                if (Array.isArray(matchingTP?.treatmentProtocolICD10s?.treatmentProtocolICD10)) {
                    icd10sTemp = matchingTP?.treatmentProtocolICD10s?.treatmentProtocolICD10.map((o) => o.icd10);
                } else {
                    icd10sTemp = matchingTP?.treatmentProtocolICD10s?.treatmentProtocolICD10?.icd10;
                }
                if (!Array.isArray(icd10sTemp)) icd10sTemp = [icd10sTemp];
                let clone = structuredClone(icd10sTemp);
                clone = clone.filter((el) => !cloneDiagnoses.some((el2) => el2.code === el.code));
                cloneDiagnoses = [...cloneDiagnoses, ...clone];
            }
        }
        dispatch(setNewPrescription({...newPrescription, diagnoses: cloneDiagnoses}));
    }

     const fetchCommercialUsageAvailability = () => {
         axios.get(`${process.env.REACT_APP_API_URL2}/prescription/commercial-usage-availability`, {
             headers: { 'Content-Type': 'application/json' },
             params: {
                 company: company.id,
             }
         }).then((res) => {
             if (+res.data.totalNoInnValue && +res.data.totalValue) {
                 if (+res.data.totalNoInnValue / +res.data.totalValue > 0.15) setCommercialUsageAvailable(false);
             }
         }).catch((err) => {
             console.log(err);
         })
     }

    const onIFETUpdate = {
        insert: (e, data) => {
            let defaultIFET = {
                erp_active_substance: "",
                erp_form: "",
                erp_content: "",
                erp_participationPercentage: "",
                erp_doseAmount: "",
                erp_doseUnit: "",
                erp_frequency: "",
                erp_days: "",
                erp_notes: "",
            }
            defaultIFET = {...defaultIFET, [data.field] : data.value};
            let cloneIFET = structuredClone(newPrescription.ifet);
            cloneIFET.push(defaultIFET);
            dispatch(setNewPrescription({...newPrescription, ifet: cloneIFET}));
        },
        update: (data, id, rowIndex) => {
            let cloneIFET = structuredClone(newPrescription.ifet);
            cloneIFET[rowIndex] = {...cloneIFET[rowIndex], ...data};
            dispatch(setNewPrescription({...newPrescription, ifet: cloneIFET}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            let cloneIFET = structuredClone(newPrescription.ifet);
            cloneIFET.splice(rowIndex, 1);
            dispatch(setNewPrescription({...newPrescription, ifet: cloneIFET}));
        }
    }

    return (
        <React.Fragment>
            {/* New Prescription Modal */}
            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal95PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Νέα συνταγή</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={"borderedContainer mb-2"}>
                        <Row>
                            <Col md={2}>
                                <Input
                                    label={"Ημ/νια έκδοσης συνταγής"}
                                    value={moment(newPrescription.date).format("DD/MM/YYYY")}
                                    disabled={true}
                                />
                            </Col>
                            <Col md={3}>
                                <Dropdown
                                    name={"type"}
                                    label={"Είδος Συνταγής"}
                                    options={prescriptionTypes}
                                    defaultValue={prescriptionTypes.find((el) => el.value === newPrescription.type)}
                                    key={Math.random()}
                                    onChange={(e) => handleOnChange(e, "dd", "type")}
                                />
                            </Col>
                        </Row>
                        {newPrescription.type !== "consumable" && (
                            <Row>
                                <Col md={2}>
                                    <Dropdown
                                        name={"repeat"}
                                        label={"Επαναλήψεις"}
                                        options={prescriptionRepeatOptions}
                                        defaultValue={prescriptionRepeatOptions.find((el) => el.value === newPrescription.repeat)}
                                        key={Math.random()}
                                        onChange={(e) => handleOnChange(e, "dd", "repeat")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <Dropdown
                                        name={"repeatPeriod"}
                                        label={"Περίοδος Επανάληψης"}
                                        options={prescriptionRepeatPeriodOptions}
                                        defaultValue={prescriptionRepeatPeriodOptions.find((el) => el.value === newPrescription.repeatPeriod)}
                                        key={Math.random()}
                                        disabled={newPrescription.repeat === "1"}
                                        onChange={(e) => handleOnChange(e, "dd", "repeatPeriod")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <div style={{marginTop: "30px"}}>
                                        <BetterCheckBox
                                            name={"monthlyTreatment"}
                                            text={"Θεραπεία μηνός"}
                                            checked={newPrescription.monthlyTreatment || (newPrescription.repeat === "1" && newPrescription.bimonthlyTreatment)}
                                            onChange={(e) => handleOnChange(e, "cb", "monthlyTreatment")}
                                        />
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div style={{marginTop: "30px"}}>
                                        <BetterCheckBox
                                            name={"bimonthlyTreatment"}
                                            text={"Δίμηνη Θεραπεία"}
                                            checked={newPrescription.bimonthlyTreatment}
                                            disabled={+newPrescription.repeat >= 2 || (newPrescription.repeat === "1" && newPrescription.monthlyTreatment)}
                                            onChange={(e) => handleOnChange(e, "cb", "bimonthlyTreatment")}
                                        />
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div style={{marginTop: "30px"}}>
                                        <BetterCheckBox
                                            name={"chronicIllness"}
                                            text={"Χρόνια Πάθηση"}
                                            checked={newPrescription.chronicIllness}
                                            disabled={+newPrescription.repeat >= 2 || (newPrescription.repeat === "1" && newPrescription.monthlyTreatment) || (newPrescription.repeat === "2" && newPrescription.bimonthlyTreatment)}
                                            onChange={(e) => handleOnChange(e, "cb", "chronicIllness")}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        )}
                        <Row className={"mb-2"}>
                            <Col md={3}>
                                <Dropdown
                                    className={"m-0"}
                                    name={"zeroParticipationReason"}
                                    label={"Περιπτώσεις μηδενικής συμμετοχής για όλη τη συνταγή"}
                                    options={getZeroParticipationReasonOptions()}
                                    defaultValue={getZeroParticipationReasonOptions().find((el) => el.value === newPrescription.zeroParticipationReason)}
                                    key={Math.random()}
                                    onChange={(e) => handleOnChange(e, "dd", "zeroParticipationReason")}
                                />
                                {!isEmpty(newPrescription.zeroParticipationReason) && (
                                    <div><img height={"16px"} src={"assets/images/warning.png"} alt={"Warning"} /> Η συνταγή θα πρέπει να περιλαμβάνει μόνο φάρμακα για την ασθένεια με μηδενική συμμετοχή που επιλέξατε</div>
                                )}
                            </Col>
                            <Col md={2}>
                                <div style={{marginTop: "30px"}}>
                                    <BetterCheckBox
                                        name={"oneDose"}
                                        text={"Μονοδοσικά"}
                                        checked={newPrescription.oneDose}
                                        disabled={newPrescription.type === "ifet"}
                                        onChange={(e) => handleOnChange(e, "cb", "oneDose")}
                                    />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className={newPrescription.prescriptionWithCommercialName ? "borderedContainer" : ""} style={{marginTop: "30px"}}>
                                    <BetterCheckBox
                                        name={"prescriptionWithCommercialName"}
                                        text={!commercialUsageAvailable ? (
                                            <span>Συνταγογράφηση με εμπορική ονομασία <br/> <img src={"assets/images/warning.png"} alt={"Warning"} /> <u>
                                                    (Έχετε ξεπεράσει το όριο συνταγογράφησης με εμπορική ονομασία)</u></span>
                                        ) : (
                                            <span>Συνταγογράφηση με εμπορική ονομασία</span>
                                        )}
                                        disabled={newPrescription.type === "ifet"}
                                        checked={newPrescription.prescriptionWithCommercialName}
                                        onChange={(e) => handleOnChange(e, "cb", "prescriptionWithCommercialName")}
                                    />
                                    {newPrescription.prescriptionWithCommercialName && (
                                        <React.Fragment>
                                            <Dropdown
                                                className={"mt-0 mb-1"}
                                                name={"prescriptionWithCommercialNameCause"}
                                                label={"Αιτιολογία"}
                                                key={Math.random()}
                                                options={getNoInnCasesOptions()}
                                                defaultValue={getNoInnCasesOptions().find((el) => el.value === newPrescription.prescriptionWithCommercialNameCause)}
                                                onChange={(e) => handleOnChange(e, "dd", "prescriptionWithCommercialNameCause")}
                                            />
                                            <TextArea
                                                name={"prescriptionWithCommercialNameNotes"}
                                                label={"Σχόλια"}
                                                rows={3}
                                                value={newPrescription.prescriptionWithCommercialNameNotes}
                                                onChange={(e) => handleOnChange(e, "input", "prescriptionWithCommercialNameNotes")}
                                            />
                                        </React.Fragment>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className={newPrescription.medicalOpinion ? "borderedContainer" : ""} style={{marginTop: "30px"}}>
                                    <BetterCheckBox
                                        name={"medicalOpinion"}
                                        text={"Ιατρική γνωμάτευση"}
                                        className={"m-0"}
                                        checked={newPrescription.medicalOpinion}
                                        onChange={(e) => handleOnChange(e, "cb", "medicalOpinion")}
                                    />
                                    {newPrescription.medicalOpinion && (
                                        <React.Fragment>
                                            <hr className={"mt-2 mb-2"} />
                                            <BetterCheckBox
                                                name={"medicalOpinionByNumber"}
                                                className={"m-0"}
                                                text={"Εισαγωγή με αριθμό γνωμάτευσης"}
                                                checked={newPrescription.medicalOpinionByNumber}
                                                onChange={(e) => handleOnChange(e, "cb", "medicalOpinionByNumber")}
                                            />
                                            {newPrescription.medicalOpinionByNumber ? (
                                                <React.Fragment>
                                                    <Row>
                                                        <Col md={7}>
                                                            <Input
                                                                name={"medicalOpinionNumber"}
                                                                className={"m-0"}
                                                                label={"Αριθμός γνωμάτευσης"}
                                                                placeholder={"Αριθμός γνωμάτευσης"}
                                                                value={newPrescription.medicalOpinionNumber}
                                                                autoComplete={"off"}
                                                                onChange={(e) => handleOnChange(e, "input", "medicalOpinionNumber")}
                                                            />
                                                        </Col>
                                                        <Col md={5}>
                                                            <Button size={"sm"} style={{marginTop: "28px", width: "100%"}} onClick={() => handleFetchMedicalOpinion()}>Αναζήτηση</Button>
                                                        </Col>
                                                    </Row>
                                                    {newPrescription.medicalOpinionIdentifier && (
                                                        <Row className={"mt-1"}>
                                                            <Col md={12}>
                                                                <strong>Στοιχεία γνωμάτευσης</strong><br/>
                                                                <strong>Γιατρός:</strong> {newPrescription.medicalOpinionIdentifier}<br/>
                                                                <strong>Ημερομηνία Γνωμάτευσης:</strong> {newPrescription.medicalOpinionDate}
                                                            </Col>
                                                        </Row>
                                                    )}
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <Row>
                                                        <Col md={7}>
                                                            <Input
                                                                name={"medicalOpinionAMKA"}
                                                                label={"ΑΜΚΑ ιατρού γνωμάτευσης"}
                                                                value={newPrescription.medicalOpinionAMKA}
                                                                autoComplete={"off"}
                                                                onChange={(e) => handleOnChange(e, "input", "medicalOpinionAMKA")}
                                                            />
                                                        </Col>
                                                        <Col md={5}>
                                                            <Button size={"sm"} style={{marginTop: "28px", width: "100%"}} onClick={() => handleFetchOtherDoctor()}>Αναζήτηση</Button>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={12}>
                                                            <DateBox
                                                                name={"medicalOpinionDate"}
                                                                label={"Ημερομηνία Γνωμάτευσης"}
                                                                className={"mt-1"}
                                                                allowOtherYears={true}
                                                                selected={moment(newPrescription.medicalOpinionDate, "DD/MM/YYYY").isValid() ? moment(newPrescription.medicalOpinionDate, "DD/MM/YYYY").toDate() : ""}
                                                                onChange={(e) => handleOnChange(e, "db", "medicalOpinionDate")}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    {newPrescription.medicalOpinionIdentifier && (
                                                        <Row className={"mt-1"}>
                                                            <Col md={12}>
                                                                <strong>Στοιχεία ιατρού γνωμάτευσης:</strong><br/> {newPrescription.medicalOpinionIdentifier}
                                                            </Col>
                                                        </Row>
                                                    )}
                                                </React.Fragment>
                                            )}
                                        </React.Fragment>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={2}>
                                <BetterCheckBox
                                    name={"ekasLoss"}
                                    text={"Απώλεια ΕΚΑΣ"}
                                    checked={newPrescription.ekasLoss === "true"}
                                    disabled={ekasLoss !== "true"} // From visit setting
                                    onChange={(e) => handleOnChange(e, "cb_string", "ekasLoss")}
                                />
                            </Col>
                            <Col md={3}>
                                <BetterCheckBox
                                    name={"activePartException"}
                                    text={"Απαλλαγή ασφαλισμένου από κάθε συμμετοχή"}
                                    className={"mb-0"}
                                    checked={hasActivePartException}
                                    disabled={true}
                                />
                                {hasActivePartException && (
                                    <span><strong>Λόγος απαλλαγής: </strong> {newPrescription.activePartException?.exceptionReason}</span>
                                )}
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <div className={"borderedContainer"}>
                                <div style={{display: "flex", textAlign: "center"}}>
                                    <div className={"mb-1"} style={{fontSize: "20px"}}>Διαγνώσεις</div>
                                    <Button size={"sm"} onClick={() => setICD10Modal(true)} className={"ml-2"}>Εισαγωγή Διαγνώσεων ICD10</Button>
                                    {activeVisitTreatmentProtocolsSteps?.length > 0 && (
                                        <Button size={"sm"} variant={"outline-primary"} className={"ml-1"} onClick={() => handleAddTPICD10s()}>Εισαγωγή διαγνώσεων Θ.Π.</Button>
                                    )}
                                </div>
                                {newPrescription.diagnoses.length > 0 && (
                                    <React.Fragment>
                                        <table className={"simpleClassicTable mt-1"}>
                                            <colgroup>
                                                <col span={1} style={{width: "20%"}}></col>
                                                <col span={1} style={{width: "70%"}}></col>
                                                <col span={1} style={{width: "10%"}}></col>
                                            </colgroup>
                                            <thead>
                                            <tr>
                                                <th>Κωδικός</th>
                                                <th>Τίτλος</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {newPrescription.diagnoses.map((diag, idx) => (
                                                <tr key={`diagnoses-${idx}`}>
                                                    <td>{diag.code}</td>
                                                    <td>{diag.title}</td>
                                                    <td><Badge bg={"danger"}
                                                               title={"Διαγραφή"}
                                                               style={{cursor: "pointer"}}
                                                               onClick={() => handleICD10Check({target: {checked: false}}, diag)}>
                                                        <img title="Διαγραφή" src={"assets/images/callcenter/bin.png"} alt={"Bin"} />
                                                    </Badge></td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </React.Fragment>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <Row className={"mt-2"}>
                        <Col md={12}>
                            <div className={"borderedContainer"}>
                                <div style={{display: "flex", textAlign: "center"}}>
                                    <div className={"mb-1"} style={{fontSize: "20px"}}>Θεραπείες συνταγής</div>
                                    {newPrescription.type === "normal" ? (
                                        <Button size={"sm"} onClick={() => setShowChooseDrugModal(true)} className={"ml-2"}>Εισαγωγή Φαρμάκων</Button>
                                    ) : newPrescription.type === "consumable" ? (
                                        <React.Fragment>
                                            <div className={"ml-2 mt-1"}>Κατηγορία αναλωσίμου</div>
                                            <div style={{maxWidth: "20%"}}>
                                                <Dropdown
                                                    name={"consumableCategory"}
                                                    className={"ml-2"}
                                                    options={consumableCategories}
                                                    key={Math.random()}
                                                    defaultValue={consumableCategories.find((el) => el.value === newPrescription.consumableCategory)}
                                                    onChange={(e) => handleOnChange(e, "dd", "consumableCategory")}
                                                />
                                            </div>
                                            <Button size={"sm"} onClick={() => setShowConsumablesModal(true)}
                                                    className={"ml-2"} disabled={isEmpty(newPrescription.consumableCategory)}>Εισαγωγή Αναλωσίμων</Button>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment></React.Fragment>
                                    )}
                                </div>
                                {newPrescription.drugs.length > 0 && (
                                    <React.Fragment>
                                        {newPrescription.drugs.some((el) => el.isDeliverable === "true") && (
                                            <Badge bg={"primary"} style={{fontSize: "14px", padding: "5px"}} className={"mr-1 mt-1"}>Δυνατότητα Παράδοσης Κατ' Οίκον</Badge>
                                        )}
                                        {newPrescription.drugs.some((el) => el.highCost === "true") && (
                                            <Badge bg={"primary"} style={{fontSize: "14px", padding: "5px"}} className={"mr-1 mt-1"}>Υψηλού κόστους</Badge>
                                        )}
                                        {newPrescription.drugs.some((el) => el.drug === "true") && (
                                            <Badge bg={"primary"} style={{fontSize: "14px", padding: "5px"}} className={"mr-1 mt-1"}>Ναρκωτικά</Badge>
                                        )}
                                        {newPrescription.drugs.some((el) => el.notInPharCost === "true") && (
                                            <Badge bg={"primary"} style={{fontSize: "14px", padding: "5px"}} className={"mr-1 mt-1"}>Εκτός φαρμακευτικής δαπάνης Ε.Ο.Π.Υ.Υ.</Badge>
                                        )}
                                        {newPrescription.drugs.some((el) => el.ifet === "true") && (
                                            <Badge bg={"primary"} style={{fontSize: "14px", padding: "5px"}} className={"mr-1 mt-1"}>Ι.Φ.Ε.Τ.</Badge>
                                        )}
                                        <table className={"simpleClassicTable mt-1"}>
                                            <colgroup>
                                                <col span={1} style={{width: "3%"}}></col>
                                                <col span={1} style={{width: "17%"}}></col>
                                                <col span={1} style={{width: "17%"}}></col>
                                                <col span={1} style={{width: "10%"}}></col>
                                                <col span={1} style={{width: "10%"}}></col>
                                                <col span={1} style={{width: "10%"}}></col>
                                                <col span={1} style={{width: "10%"}}></col>
                                                <col span={1} style={{width: "10%"}}></col>
                                                <col span={1} style={{width: "10%"}}></col>
                                                <col span={1} style={{width: "3%"}}></col>
                                            </colgroup>
                                            <thead>
                                            <tr>
                                                <th></th>
                                                <th>Δραστική Ουσία</th>
                                                <th>Προτεινόμενη Θεραπεία</th>
                                                <th>Ποσότητα</th>
                                                <th>Συμμετοχή (%)</th>
                                                <th>Ποσό Δόσης</th>
                                                <th>Μονάδα Δόσης</th>
                                                <th>Συχνότητα</th>
                                                <th>Ημέρες</th>
                                                <th>&nbsp;</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {newPrescription.drugs.map((drug, idx) => (
                                                <React.Fragment>
                                                    <tr key={`drugsTable-${idx}`}>
                                                        {extraInfoDrugs.includes(drug.id) ? (
                                                            <td><Badge bg={"dark"} style={{cursor: "pointer"}} onClick={() => setExtraInfoDrugs(extraInfoDrugs.filter((el) => el !== drug.id))}>-</Badge></td>
                                                        ) : (
                                                            <td><Badge bg={"dark"} style={{cursor: "pointer"}} onClick={() => setExtraInfoDrugs([...extraInfoDrugs, drug.id])}>+</Badge></td>
                                                        )}
                                                        <td>{getActiveSubstance(drug)}</td>
                                                        <td>{drug.formCode} x {drug.content} x {drug.packageForm}</td>
                                                        <td>
                                                            <Dropdown
                                                                name={"erp_drugAmount"}
                                                                className={"m-0"}
                                                                options={getPrescriptionDrugAmountOptions(+newPrescription.repeat)}
                                                                key={Math.random()}
                                                                defaultValue={getPrescriptionDrugAmountOptions(+newPrescription.repeat).find((el) => el.value === drug.erp_drugAmount)}
                                                                onChange={(e) => handleOnDrugChange(e, "dd", "erp_drugAmount", idx)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Dropdown
                                                                name={"erp_participationPercentage"}
                                                                className={"m-0"}
                                                                options={prescriptionParticipationPercentageOptions}
                                                                key={Math.random()}
                                                                defaultValue={prescriptionParticipationPercentageOptions.find((el) => el.value === drug.erp_participationPercentage)}
                                                                onChange={(e) => handleOnDrugChange(e, "dd", "erp_participationPercentage", idx)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Dropdown
                                                                name={"erp_doseAmount"}
                                                                className={"m-0"}
                                                                options={prescriptionDoseAmountOptions}
                                                                key={Math.random()}
                                                                defaultValue={prescriptionDoseAmountOptions.find((el) => el.value === drug.erp_doseAmount)}
                                                                onChange={(e) => handleOnDrugChange(e, "dd", "erp_doseAmount", idx)}
                                                            />
                                                        </td>
                                                        <td>
                                                            {drug.doseUnit}
                                                        </td>
                                                        <td>
                                                            <Dropdown
                                                                name={"erp_frequency"}
                                                                className={"m-0"}
                                                                options={prescriptionFrequencyOptions}
                                                                key={Math.random()}
                                                                defaultValue={prescriptionFrequencyOptions.find((el) => el.value === drug.erp_frequency)}
                                                                onChange={(e) => handleOnDrugChange(e, "dd", "erp_frequency", idx)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Dropdown
                                                                name={"erp_days"}
                                                                className={"m-0"}
                                                                options={daysAmount}
                                                                key={Math.random()}
                                                                defaultValue={daysAmount?.find((el) => el.value === drug.erp_days)}
                                                                onChange={(e) => handleOnDrugChange(e, "dd", "erp_days", idx)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Badge bg={"danger"}
                                                                   title={"Διαγραφή"}
                                                                   style={{cursor: "pointer"}}
                                                                   onClick={() => handleDrugCheck(false, drug)}>
                                                                <img title="Διαγραφή" src={"assets/images/callcenter/bin.png"} alt={"Bin"} />
                                                            </Badge>
                                                        </td>
                                                    </tr>
                                                    {extraInfoDrugs.includes(drug.id) && (
                                                        <tr key={`drugsTable-${idx}-ei`} style={{textAlign: "left"}}>
                                                            <td colSpan={10} style={{backgroundColor: "#f5f5f5"}} className={"p-1"}>
                                                                <Row>
                                                                    <Col md={4}>
                                                                        <TextArea
                                                                            name={"erp_notes"}
                                                                            label={"Σχόλια"}
                                                                            rows={3}
                                                                            value={drug.erp_notes}
                                                                            limit={100}
                                                                            onChange={(e) => handleOnDrugChange(e, "input", "erp_notes", idx)}
                                                                        />
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <Dropdown
                                                                            name={"erp_correlated_icd10s"}
                                                                            label={"Συσχέτιση με διαγνώσεις"}
                                                                            key={Math.random()}
                                                                            multiSelect={true}
                                                                            required={true}
                                                                            options={getMultiselectICD10sOptions(newPrescription.diagnoses)}
                                                                            defaultValue={getMultiselectICD10sOptions(newPrescription.diagnoses).filter((el) => drug.erp_correlated_icd10s?.includes(el.value))}
                                                                            onChange={(e) => handleOnDrugChange(e, "msdd", "erp_correlated_icd10s", idx)}
                                                                        />
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <div style={{marginTop: "30px"}}>
                                                                            <BetterCheckBox
                                                                                name={"erp_generic_cluster"}
                                                                                text={"Προτείνεται η χορήγηση γεννόσημου φαρμάκου"}
                                                                                checked={drug.erp_generic_cluster === "true"}
                                                                                disabled={drug.inClusterWithGeneric === "false"}
                                                                                onChange={(e) => handleOnDrugChange(e, "cb", "erp_generic_cluster", idx)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                {!isEmpty(drug.participationPercentage) ? (
                                                                    <Row>
                                                                        <Col md={12}>
                                                                            <strong>Προτεινόμενο Ποσοστό Συμμετοχής Ασφαλισμένου από τον Ε.Ο.Φ.:</strong>
                                                                            <Badge bg={"primary"} className={"ml-2"} style={{padding: "3px", fontSize: "14px", fontWeight: "600"}}>
                                                                                {drug.participationPercentage} %
                                                                            </Badge>
                                                                        </Col>
                                                                    </Row>
                                                                ) : (
                                                                    <Row>
                                                                        <Col md={12}>
                                                                            <strong>Μη διαθέσιμο προτεινόμενο ποσό συμμετοχής από τον Ε.Ο.Φ. .</strong>
                                                                        </Col>
                                                                    </Row>
                                                                )}
                                                                {!isEmpty(drug?.erp_tpstep_description) && (
                                                                    <div className={"mt-1"}>
                                                                        <strong>Συσχετιζόμενο με το βήμα Θ.Π:</strong> {drug.erp_tpstep_description}
                                                                    </div>
                                                                )}
                                                                {!isEmpty(drug.infoPopUp) && (
                                                                    <div style={{lineHeight: "20px", fontSize: "16px"}} className={"mt-2"}>
                                                                        <img src={"/assets/images/warning.png"} height={"18px"} alt={"Warning"} />
                                                                        <strong>Προσοχή:</strong> {drug.infoPopUp}
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                            </tbody>
                                        </table>
                                    </React.Fragment>
                                )}
                                {newPrescription.type === "ifet" && (
                                    <React.Fragment>
                                        <IFETDrugTable
                                            data={newPrescription.ifet}
                                            onUpdate={onIFETUpdate}
                                            daysAmount={daysAmount}
                                        />
                                    </React.Fragment>
                                )}
                            </div>
                        </Col>
                    </Row>
                    {!isEmpty(lastError) && (
                        <Row className={"mt-2"}>
                            <Col md={12} style={{fontSize: "16px", fontWeight: "600"}}>
                                <div className={"text-danger"}>Τελευταίο μήνυμα σφάλματος:</div>
                                <div className={"text-danger"}>{lastError}</div>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {/*
                    // Disabled on update 25/06/2025. It is going to be available from another platform
                    {newPrescription.drugs.some((el) => el.isDeliverable === "true") && noPaperConstent === "true" && (
                        <BetterCheckBox
                            className={"mb-0 mr-3"}
                            name={"homeDelivery"}
                            checked={newPrescription.homeDelivery}
                            text={"Ο ασθενής επιθυμεί παράδοση κατ΄ οίκον"}
                            onChange={(e) => handleOnChange(e, "cb", "homeDelivery")}
                        />
                    )}
                    */}
                    <Button variant="primary" onClick={() => handleSavePrescription()} disabled={loading}>
                        Ολοκλήρωση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Overrides Modal */}
            <Modal show={showOverrides} onHide={() => setShowOverrides(false)} backdrop={"static"} dialogClassName={"modal95PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Εξαιρέσεις/Υπερβάσεις Συνταγής</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showOverrides && (
                        <div className={"borderedContainer mb-2 mt-2"}>
                            {!isEmpty(lastError) && (
                                <Row>
                                    <Col md={12} style={{fontSize: "16px", fontWeight: "600"}}>
                                        <div className={"text-danger"}>{lastError}</div>
                                    </Col>
                                </Row>
                            )}
                            {newPrescription.overrides.length > 0 && (
                                <React.Fragment>
                                    <table className={"simpleClassicTable mt-1"}>
                                        <colgroup>
                                            <col span={1} style={{width: "5%"}}></col>
                                            <col span={1} style={{width: "20%"}}></col>
                                            <col span={1} style={{width: "15%"}}></col>
                                            <col span={1} style={{width: "35%"}}></col>
                                            <col span={1} style={{width: "30%"}}></col>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>Αποδοχή υπέρβασης</th>
                                            <th>Διάγνωση</th>
                                            <th>Εξαίρεση</th>
                                            <th>Περιγραφή</th>
                                            <th>Αιτιολόγηση</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {newPrescription.overrides.map((over, idx) => (
                                            <tr key={`overrides-${idx}`}>
                                                <td style={{zoom: "1.3"}}>
                                                    <input name={"erp_checked"} type={"checkbox"} checked={over.erp_checked}
                                                           onChange={(e) => handleOverrideChange(e, "cb", "erp_checked", idx)} />
                                                </td>
                                                <td>{over.icd10Code}</td>
                                                <td>{over.erp_override_name}</td>
                                                <td>{over.violationDetails}</td>
                                                <td>
                                                    {referralOverrides.find((el) => el.id === over.overrideTypeId)?.reasons ? (
                                                        <Dropdown
                                                            name={"erp_reasonId"}
                                                            className={"m-0"}
                                                            key={Math.random()}
                                                            options={referralOverrides.find((el) => el.id === over.overrideTypeId)?.reasons}
                                                            defaultValue={referralOverrides.find((el) => el.id === over.overrideTypeId).reasons.find((el) => el.value === over.erp_reasonId)}
                                                            onChange={(e) => handleOverrideChange(e, "dd", "erp_reasonId", idx)}
                                                        />
                                                    ) : (
                                                        <Input
                                                            name={"erp_cause"}
                                                            unlabbled={true}
                                                            value={over.erp_cause}
                                                            placeholder={"Αιτιολογία"}
                                                            autoComplete={"off"}
                                                            onChange={(e) => handleOverrideChange(e, "input", "erp_cause", idx)}
                                                        />
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </React.Fragment>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowOverrides(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => handleSavePrescription()} disabled={loading}>
                        Τελική καταχώρηση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>

            <ICD10Modal
                show={icd10modal}
                setShow={setICD10Modal}
                diagnoses={newPrescription.diagnoses}
                handleCheck={(e, item) => handleICD10Check(e, item)}
                backButtonMessage={"Πίσω στην συνταγή"}
                recommendedICD10Array={[]}
            />

            <DrugsModal
                show={showChooseDrugModal}
                setShow={setShowChooseDrugModal}
                handleDrugCheck={(checked, drug) => handleDrugCheck(checked, drug)}
                newPrescriptionDrugs={newPrescription.drugs}
                treatmentProtocolSteps={activeVisitTreatmentProtocolsSteps}
            />

            <ConsumablesModal
                show={showConsumablesModal}
                setShow={setShowConsumablesModal}
                consumableCategory={newPrescription.consumableCategory}
                handleAdd={(item) => handleAddConsumable(item)}
            />
        </React.Fragment>
    )
}

export default NewPrescriptionModal;
